import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/styles.css";
import "./i18n";
import { PortalClientes } from "./PortalClientes";
import { ToastContainer, Zoom } from "react-toastify";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <PortalClientes />
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Zoom}
        />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
